import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { AddonTemplateInterface, setEditId, setEditError, selectAddonTemplateById } from "../../../store/mine_craft/addonTemplatesSlice";
import { updateAddonTemplate, fetchAddonTemplate } from "../../../actions/mine_craft/addonTemplatesActions";
import { objToFormData } from "../../../helpers/FormHelper";
import { fetchCategories } from "../../../actions/mine_craft/categoriesActions";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const TARGET_ID = 3;

const Edit = () => {
  const navigate      = useNavigate();
  const dispatch      = useAppDispatch();
  const location      = useLocation();
  const id: any       = useAppSelector(state => state.mineCraft.addonTemplates.editId);
  const error         = useAppSelector(state => state.mineCraft.addonTemplates.editError);
  const addonTemplate = useAppSelector(state => id ? selectAddonTemplateById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchCategories({ target_id: TARGET_ID }));
      dispatch(fetchAddonTemplate(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: AddonTemplateInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: AddonTemplateInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updateAddonTemplate({ id, data: formData }));

    if (updateAddonTemplate.fulfilled.match(resultAction)) {
      onClose();

      if (addonTemplate?.category_id !== data.category_id || addonTemplate?.subcategory_id !== data.subcategory_id) {
        navigate(0);
      }
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-addonTemplate'>
        <h6 className="v-content-label">Edit AddonTemplate</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={addonTemplate} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
